import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Summary from './Summary';

const steps = {
  1: {
    title: 'Create a Trade Account',
    component: Step1,
  },
  2: {
    title: 'Company Details',
    component: Step2,
  },
  3: {
    title: 'Addresses',
    component: Step3,
  },
  4: {
    title: 'Contact Details',
    component: Step4,
  },
  5: {
    title: 'Summary',
    component: Summary,
    hasNav: false,
  },
};

export default steps;
